import { SvgIcon, SvgIconProps } from "@mui/material";

export const CreateJobIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99984 4.16669V15.8334M4.1665 10H15.8332"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ListItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#C9FFC4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.2483 6.15838L8.28164 11.9167L6.69831 10.2251C6.40664 9.95005 5.94831 9.93338 5.61497 10.1667C5.28997 10.4084 5.19831 10.8334 5.39831 11.1751L7.27331 14.2251C7.45664 14.5084 7.77331 14.6834 8.13164 14.6834C8.47331 14.6834 8.79831 14.5084 8.98164 14.2251C9.28164 13.8334 15.0066 7.00838 15.0066 7.00838C15.7566 6.24172 14.8483 5.56672 14.2483 6.15005V6.15838Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const HeaderBackArrowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8346 10H4.16797M4.16797 10L9.16797 5M4.16797 10L9.16797 15"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const GoHireGoalngoLogoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "89", height: "32", fill: "none" }}
      width="89"
      height="32"
      viewBox="0 0 89 32"
      fill="none"
    >
      <path
        d="M35.4246 15.775H36.9136V18.261C36.9136 20.0108 36.6361 20.9644 35.4971 20.9644C34.5477 20.9644 34.1531 20.252 34.1531 18.8884V10.177C34.1531 8.8176 34.5616 8.15532 35.518 8.15532C36.717 8.15532 36.848 9.19271 36.848 10.0906V10.7724H39.4747V10.2202C39.4747 8.39236 39.0982 5.76282 35.5222 5.76282C32.5637 5.76282 31.4805 7.80958 31.4805 10.5911V18.5886C31.4805 21.4747 32.2877 23.2886 34.793 23.2886C35.8916 23.2886 36.8801 22.8941 37.3527 21.762C37.375 22.1245 37.4266 22.7407 37.4963 23.0405H39.543V13.5163H35.4246V15.775Z"
        fill="black"
      />
      <path
        d="M44.7781 9.64307C42.4847 9.64307 40.8633 10.9327 40.8633 13.7896V18.986C40.8633 21.762 42.132 23.2455 44.7028 23.2455C47.2737 23.2455 48.5954 21.7968 48.5954 18.9707V13.8997C48.5954 11.1112 47.1677 9.64443 44.7781 9.64443V9.64307ZM45.966 19.032C45.966 20.2701 45.6272 20.9184 44.7502 20.9184C43.8148 20.9184 43.4927 20.1432 43.4927 19.0766V13.7463C43.4927 12.5807 43.8733 11.9673 44.7321 11.9673C45.6955 11.9673 45.9674 12.7077 45.9674 13.7241V19.032H45.966Z"
        fill="black"
      />
      <path
        d="M57.136 13.1789C57.136 11.0471 56.2451 9.64307 53.698 9.64307C50.7995 9.64307 50.0661 11.3342 50.0661 13.2444V13.4145H52.6468V13.1998C52.6468 12.38 52.8266 11.7735 53.6046 11.7735C54.3825 11.7735 54.5275 12.3549 54.5275 13.388V15.0723H54.225C51.8465 15.0723 49.6562 15.9368 49.6562 19.1882V19.4182C49.6562 21.4092 50.4565 23.2469 52.4404 23.2469C53.4554 23.2469 54.1678 22.883 54.6167 22.0757C54.639 22.2625 54.7324 22.7951 54.7854 23.0433H57.1848C57.1374 22.5414 57.1332 21.1736 57.1332 20.3412V13.1803L57.136 13.1789ZM54.5777 18.5719C54.5777 20.351 54.1887 20.9588 53.3104 20.9588C52.4906 20.9588 52.1532 20.2966 52.1532 19.3653V19.1589C52.1532 17.5137 52.9423 17.0605 54.1399 17.0605H54.5777V18.5719Z"
        fill="black"
      />
      <path d="M61.4899 5.27075H58.8633V23.0406H61.4899V5.27075Z" fill="black" />
      <path
        d="M68.1803 9.64307C66.8377 9.64307 66.1309 10.2816 65.7489 11.0471C65.7489 10.6664 65.7014 10.1506 65.6527 9.84662H63.1445C63.1696 10.4448 63.1696 11.2367 63.1696 13.9178V23.0419H65.7963V14.2859C65.7963 12.4943 66.195 11.9979 67.1291 11.9979C67.8527 11.9979 68.2639 12.4162 68.2639 13.6069V23.0419H70.8906V13.1105C70.8906 10.6176 69.785 9.64307 68.1803 9.64307Z"
        fill="black"
      />
      <path
        d="M77.6031 11.0094C77.3828 10.2885 76.8126 9.6416 75.4267 9.6416C72.8935 9.6416 72.2188 11.8585 72.2188 13.6515V18.6346C72.2188 20.9003 72.7444 22.77 75.1493 22.77C76.2577 22.77 76.9882 22.289 77.3214 21.5584V22.9987C77.3214 24.662 77.1388 25.4985 76.0485 25.4985C74.9583 25.4985 74.8677 24.595 74.8677 24.2353V24.1782H72.2383V24.2325C72.2383 25.6951 72.7681 27.6667 75.9077 27.6667C79.6636 27.6667 79.9481 25.2295 79.9481 22.3043V13.1426C79.9481 11.7525 79.9732 10.6594 79.9982 9.84659H77.7243C77.6769 10.0655 77.6031 10.6106 77.6031 11.0094ZM77.3242 17.9639C77.3242 19.5813 77.1332 20.4624 76.0137 20.4624C75.1618 20.4624 74.8482 19.7849 74.8482 18.445V13.8132C74.8482 12.5347 75.3096 11.9965 76.1503 11.9965C77.2099 11.9965 77.3242 12.9753 77.3242 14.0991V17.9639Z"
        fill="black"
      />
      <path
        d="M85.1844 9.64307C82.891 9.64307 81.2695 10.9327 81.2695 13.7896V18.986C81.2695 21.762 82.5382 23.2455 85.1091 23.2455C87.68 23.2455 89.0016 21.7968 89.0016 18.9707V13.8997C89.0016 11.1112 87.574 9.64443 85.1844 9.64443V9.64307ZM86.3722 19.032C86.3722 20.2701 86.0334 20.9184 85.1565 20.9184C84.221 20.9184 83.899 20.1432 83.899 19.0766V13.7463C83.899 12.5807 84.2796 11.9673 85.137 11.9673C86.1004 11.9673 86.3722 12.7077 86.3722 13.7241V19.032Z"
        fill="black"
      />
      <path
        d="M12.9909 2.35941L12.5894 2.76094H0V19.0487C0 19.4782 0.0250952 19.9104 0.0738913 20.3357C0.121293 20.7581 0.195185 21.1833 0.291383 21.6002C0.465655 22.3601 0.724971 23.1158 1.05957 23.8478L1.1725 24.0946L14.084 11.1823L14.0017 11.054C13.596 10.421 13.3255 9.72533 13.1987 8.98637L13.1373 8.628L2.44399 19.3234C2.4412 19.23 2.43981 19.1393 2.43981 19.0501V5.2009H10.1189L5.19191 10.1283C5.16124 10.1589 5.12778 10.191 5.09571 10.2217C5.02321 10.29 4.95211 10.3597 4.8824 10.4378L4.835 10.4852L4.82803 10.5521C4.82245 10.6009 4.82106 10.6511 4.82106 10.6929C4.81827 10.7961 4.81688 10.9007 4.81548 11.0025C4.8113 11.3524 4.8113 11.7038 4.8113 12.0537C4.8113 12.4037 4.8113 12.755 4.81548 13.1064L4.81827 13.3323C4.81827 13.4062 4.81966 13.48 4.82664 13.5539L4.86288 13.9555L12.4458 6.37213C12.4765 6.34146 12.5085 6.31076 12.542 6.28009C12.6145 6.21177 12.687 6.14204 12.7595 6.05978L14.7155 4.08549C15.0348 3.7662 15.3945 3.48455 15.7932 3.24335L15.8504 3.20849C16.719 2.68843 17.7144 2.4138 18.7294 2.4138C21.8244 2.4138 24.3423 4.93181 24.3423 8.02707C24.3423 9.07695 24.0495 10.1017 23.4946 10.9927C23.365 11.206 23.2228 11.4081 23.0848 11.5796L15.5214 19.1449C14.0198 20.6466 12.2646 22.4019 12.1475 22.519C12.1168 22.5497 12.0861 22.579 12.054 22.6083C11.9829 22.6752 11.9118 22.7435 11.8421 22.823L11.7975 22.8704L11.7905 22.9345C11.785 22.9833 11.7836 23.0321 11.7836 23.0754C11.7808 23.1785 11.7794 23.2831 11.7794 23.3849C11.7752 23.7349 11.7752 24.0862 11.7752 24.4361C11.7752 24.7861 11.7752 25.1374 11.7794 25.4874L11.7822 25.7147C11.7822 25.7886 11.7836 25.8625 11.7905 25.9364L11.8268 26.3379L16.6785 21.4845V21.4873L21.3964 16.7677V19.0487C21.3964 20.7302 20.9252 22.3741 20.0357 23.8004C19.1448 25.2281 17.8761 26.3728 16.3648 27.1103L11.916 29.2868L7.51321 27.134L5.71194 28.9341L6.01308 29.0986C6.13995 29.1683 6.26542 29.2366 6.39508 29.3007L11.9146 32L17.4342 29.3007C19.3553 28.361 20.9684 26.9054 22.1019 25.0901C23.2339 23.2762 23.832 21.1861 23.832 19.0473V14.3277L24.0927 14.0671C24.1234 14.0364 24.1541 14.007 24.1862 13.9764C24.2573 13.9094 24.3284 13.8412 24.3911 13.7687L24.4678 13.6836C27.5308 10.5354 27.5015 5.47004 24.3911 2.35805C21.2472 -0.786015 16.132 -0.786015 12.9881 2.35805L12.9909 2.35941Z"
        fill="#008B07"
      />
      <path
        d="M18.1222 13.6166L17.7639 13.5553C17.0249 13.427 16.3306 13.1565 15.6977 12.7508L15.5694 12.6685L3.90018 24.3385C3.49726 24.7205 3.09295 25.1137 2.69561 25.5083L2.29688 25.907L2.39726 26.0381C2.61196 26.3169 2.84479 26.5902 3.08598 26.8481C3.33554 27.1158 3.60182 27.3738 3.87648 27.615L4.00892 27.7321L5.70563 26.0353V26.0325L18.1208 13.6152L18.1222 13.6166Z"
        fill="#008B07"
      />
      <path
        d="M18.0296 8.72418L18.5621 10.4545L19.6119 8.97655L21.4216 8.99888L20.3439 7.54607L20.9308 5.82972L19.2132 6.41248L17.7661 5.33057L17.7842 7.14032L16.3008 8.18744L18.0296 8.72418Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const NextArrowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16797 10H15.8346M15.8346 10L10.8346 5M15.8346 10L10.8346 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const CancelButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M11 1L1 11M11 11L1 1" stroke="#414141" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const PrevButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M4.16797 10H15.8346M15.8346 10L10.8346 5M15.8346 10L10.8346 15"
        stroke="#344054"
        strokeWidth="2"
        strokeLinecap="round"
        transform="scale(-1, 1) translate(-20, 0)"
      />
    </SvgIcon>
  );
};

export const SectionAccordionArrowDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L12 16L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const GenerateButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.30526 13.4108C1.33865 13.457 1.38576 13.4916 1.43989 13.5095L2.8924 13.9932C3.21175 14.0996 3.50193 14.279 3.73994 14.517C3.97796 14.755 4.15727 15.0452 4.26366 15.3645L4.74742 16.817C4.76534 16.8711 4.79987 16.9183 4.8461 16.9516C4.89232 16.985 4.9479 17.003 5.00492 17.003C5.06194 17.003 5.11751 16.985 5.16374 16.9516C5.20997 16.9183 5.24449 16.8711 5.26242 16.817L5.74617 15.3645C5.85257 15.0452 6.03188 14.755 6.26989 14.517C6.50791 14.279 6.79809 14.0996 7.11743 13.9932L8.56994 13.5095C8.62408 13.4916 8.67118 13.457 8.70457 13.4108C8.73796 13.3646 8.75593 13.309 8.75593 13.252C8.75593 13.195 8.73796 13.1394 8.70457 13.0932C8.67118 13.0469 8.62408 13.0124 8.56994 12.9945L7.11743 12.5107C6.79809 12.4043 6.50791 12.225 6.26989 11.987C6.03188 11.749 5.85257 11.4588 5.74617 11.1395L5.26242 9.68696C5.24449 9.63283 5.20997 9.58572 5.16374 9.55234C5.11751 9.51895 5.06194 9.50098 5.00492 9.50098C4.94789 9.50098 4.89232 9.51895 4.8461 9.55234C4.79987 9.58572 4.76534 9.63283 4.74742 9.68696L4.26366 11.1395C4.04741 11.787 3.53991 12.2945 2.8924 12.5107L1.43989 12.9945C1.38576 13.0124 1.33865 13.0469 1.30526 13.0932C1.27188 13.1394 1.25391 13.195 1.25391 13.252C1.25391 13.309 1.27188 13.3646 1.30526 13.4108Z"
        fill="#00E606"
      />
      <path
        d="M7.80547 7.82192C7.39297 7.95942 7.39297 8.54192 7.80547 8.67943L10.2267 9.48568C10.7589 9.66302 11.2424 9.96183 11.639 10.3584C12.0356 10.7551 12.3344 11.2386 12.5118 11.7707L13.318 14.192C13.3477 14.2823 13.4051 14.361 13.4821 14.4167C13.5591 14.4725 13.6517 14.5025 13.7468 14.5025C13.8418 14.5025 13.9345 14.4725 14.0115 14.4167C14.0885 14.361 14.1459 14.2823 14.1755 14.192L14.9818 11.7707C15.1591 11.2386 15.4579 10.7551 15.8545 10.3584C16.2512 9.96183 16.7347 9.66302 17.2668 9.48568L19.6881 8.67942C19.7784 8.64978 19.857 8.59237 19.9128 8.51537C19.9686 8.43838 19.9986 8.34574 19.9986 8.25067C19.9986 8.1556 19.9686 8.06296 19.9128 7.98597C19.857 7.90898 19.7784 7.85156 19.6881 7.82192L17.268 7.01566C16.7357 6.83849 16.2519 6.53975 15.8551 6.14313C15.4582 5.74651 15.1592 5.2629 14.9818 4.73065L14.1755 2.30938C14.038 1.89687 13.4555 1.89687 13.318 2.30938L12.5118 4.7294C12.3346 5.26175 12.0358 5.74552 11.6392 6.14236C11.2426 6.53919 10.759 6.8382 10.2267 7.01566L7.80547 7.82192Z"
        fill="#008B07"
      />
      <path
        d="M0.03358 4.60324C0.0554231 4.63394 0.0862863 4.65706 0.121879 4.6694H0.123129L1.08939 4.99065C1.52189 5.1344 1.86064 5.47316 2.00439 5.90566L2.32689 6.87316C2.33923 6.90876 2.36236 6.93962 2.39305 6.96146C2.42374 6.98331 2.46048 6.99504 2.49815 6.99504C2.53582 6.99504 2.57255 6.98331 2.60324 6.96146C2.63393 6.93962 2.65706 6.90876 2.6694 6.87316L2.9919 5.90691C3.0628 5.69377 3.18242 5.50009 3.34126 5.34126C3.50009 5.18242 3.69377 5.06281 3.90691 4.9919L4.87441 4.6694C4.91001 4.65706 4.94087 4.63394 4.96271 4.60324C4.98455 4.57255 4.99629 4.53582 4.99629 4.49815C4.99629 4.46048 4.98455 4.42374 4.96271 4.39305C4.94087 4.36236 4.91001 4.33924 4.87441 4.3269L3.90691 4.00439C3.69377 3.93349 3.50009 3.81387 3.34126 3.65504C3.18242 3.4962 3.0628 3.30253 2.9919 3.08939L2.6694 2.12188C2.65706 2.08629 2.63393 2.05542 2.60324 2.03358C2.57255 2.01174 2.53582 2 2.49815 2C2.46047 2 2.42374 2.01174 2.39305 2.03358C2.36236 2.05542 2.33923 2.08629 2.32689 2.12188L2.00439 3.08939C1.86064 3.52189 1.52189 3.86064 1.08939 4.00439L0.121879 4.3269C0.0862862 4.33924 0.0554231 4.36236 0.03358 4.39305C0.0117369 4.42374 0 4.46048 0 4.49815C0 4.53582 0.0117369 4.57255 0.03358 4.60324Z"
        fill="#00E606"
      />
    </SvgIcon>
  );
};

export const ActiveStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" fill="#E7EFED" />
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#008B07" strokeWidth="2" />
      <circle cx="16" cy="16" r="5" fill="#008B07" />
    </SvgIcon>
  );
};

export const CompletedStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#008B07" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7953 9.8542L13.2487 19.0675L10.7153 16.3609C10.2487 15.9209 9.51534 15.8942 8.982 16.2675C8.462 16.6542 8.31534 17.3342 8.63534 17.8809L11.6353 22.7609C11.9287 23.2142 12.4353 23.4942 13.0087 23.4942C13.5553 23.4942 14.0753 23.2142 14.3687 22.7609C14.8487 22.1342 24.0087 11.2142 24.0087 11.2142C25.2087 9.98753 23.7553 8.90753 22.7953 9.84086V9.8542Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const DefaultStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EAECF0" strokeWidth="2" />
      <circle cx="16" cy="16" r="5" fill="#EAECF0" />
    </SvgIcon>
  );
};

export const CalendarInputIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2 3H16C16.5523 3 17 3.44771 17 4V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V4C1 3.44772 1.44772 3 2 3Z"
        stroke="#111111"
        strokeWidth="2"
      />
      <path d="M1 8H17" stroke="#111111" strokeWidth="2" />
      <path d="M14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM13 3H14V1H13H12V3H13Z" fill="#111111" />
      <path d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1H6ZM5 3H6V1H5H4V3H5Z" fill="#111111" />
    </SvgIcon>
  );
};

export const PlayerPositionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "13", fill: "none" }}
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path
        d="M6.6875 6.50016C6.6875 7.66307 7.50413 8.63223 8.57769 8.83632L8.57782 4.16406C7.50386 4.36815 6.6875 5.33705 6.6875 6.50023L6.6875 6.50016Z"
        fill="#707070"
      />
      <path
        d="M11.3121 6.5001C11.3121 5.33693 10.4954 4.36803 9.42188 4.16394V8.83587C10.4954 8.63205 11.3121 7.66288 11.3121 6.49997V6.5001Z"
        fill="#707070"
      />
      <path d="M15.0508 4.04785H17.9992V8.95205H15.0508V4.04785Z" fill="#707070" />
      <path
        d="M14.6326 9.81715C14.4006 9.81715 14.2123 9.62339 14.2123 9.38467V3.6153C14.2123 3.37632 14.4006 3.18282 14.6326 3.18282H18.0016V0.432615C18.0016 0.193628 17.8133 0.000130738 17.5812 0.000130738L9.42188 0V3.28976C10.961 3.50221 12.1528 4.85901 12.1528 6.49989C12.1528 8.14063 10.961 9.49756 9.42188 9.71002V12.9998H17.5809C17.8129 12.9998 18.0012 12.806 18.0012 12.5673V9.81709L14.6326 9.81715Z"
        fill="#707070"
      />
      <path d="M0 4.04785H2.94839V8.95205H0V4.04785Z" fill="#707070" />
      <path
        d="M8.57939 9.71006C7.04029 9.49761 5.84842 8.1408 5.84842 6.49991C5.84842 4.85889 7.04029 3.50223 8.57939 3.28977V0H0.42033C0.188059 0 0 0.193491 0 0.432486V3.1827H3.36895C3.60122 3.1827 3.78928 3.37619 3.78928 3.61519V9.38457C3.78928 9.6233 3.60123 9.81706 3.36895 9.81706L0 9.81732V12.5675C0 12.8063 0.188052 13 0.42033 13H8.57939V9.71006Z"
        fill="#707070"
      />
    </SvgIcon>
  );
};

export const ProfessionalJobIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "20", fill: "none" }}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M17 19C17 17.6044 17 16.9067 16.8278 16.3389C16.44 15.0605 15.4395 14.06 14.1611 13.6722C13.5933 13.5 12.8956 13.5 11.5 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z"
        stroke="#707070"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export const JobModeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "21", fill: "none" }}
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
    >
      <path
        d="M15 5.25586C15 4.32589 15 3.8609 14.8978 3.4794C14.6204 2.44413 13.8117 1.63548 12.7765 1.35808C12.395 1.25586 11.93 1.25586 11 1.25586C10.07 1.25586 9.60504 1.25586 9.22354 1.35808C8.18827 1.63548 7.37962 2.44413 7.10222 3.4794C7 3.8609 7 4.32589 7 5.25586M4.2 19.2559H17.8C18.9201 19.2559 19.4802 19.2559 19.908 19.0379C20.2843 18.8461 20.5903 18.5402 20.782 18.1638C21 17.736 21 17.176 21 16.0559V8.45586C21 7.33575 21 6.7757 20.782 6.34788C20.5903 5.97155 20.2843 5.66559 19.908 5.47385C19.4802 5.25586 18.9201 5.25586 17.8 5.25586H4.2C3.07989 5.25586 2.51984 5.25586 2.09202 5.47385C1.71569 5.66559 1.40973 5.97155 1.21799 6.34788C1 6.7757 1 7.33575 1 8.45586V16.0559C1 17.176 1 17.736 1.21799 18.1638C1.40973 18.5402 1.71569 18.8461 2.09202 19.0379C2.51984 19.2559 3.0799 19.2559 4.2 19.2559Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LocationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SalaryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 10V14M18 10V14M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const JobEndDateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 10H3M16 2V6M8 2V6M10.5 14L12 13V18M10.75 18H13.25M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SubscribeButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.30526 13.4108C1.33865 13.457 1.38576 13.4916 1.43989 13.5095L2.8924 13.9932C3.21175 14.0996 3.50193 14.279 3.73994 14.517C3.97796 14.755 4.15727 15.0452 4.26366 15.3645L4.74742 16.817C4.76534 16.8711 4.79987 16.9183 4.8461 16.9516C4.89232 16.985 4.9479 17.003 5.00492 17.003C5.06194 17.003 5.11751 16.985 5.16374 16.9516C5.20997 16.9183 5.24449 16.8711 5.26242 16.817L5.74617 15.3645C5.85257 15.0452 6.03188 14.755 6.26989 14.517C6.50791 14.279 6.79809 14.0996 7.11743 13.9932L8.56994 13.5095C8.62408 13.4916 8.67118 13.457 8.70457 13.4108C8.73796 13.3646 8.75593 13.309 8.75593 13.252C8.75593 13.195 8.73796 13.1394 8.70457 13.0932C8.67118 13.0469 8.62408 13.0124 8.56994 12.9945L7.11743 12.5107C6.79809 12.4043 6.50791 12.225 6.26989 11.987C6.03188 11.749 5.85257 11.4588 5.74617 11.1395L5.26242 9.68696C5.24449 9.63283 5.20997 9.58572 5.16374 9.55234C5.11751 9.51895 5.06194 9.50098 5.00492 9.50098C4.94789 9.50098 4.89232 9.51895 4.8461 9.55234C4.79987 9.58572 4.76534 9.63283 4.74742 9.68696L4.26366 11.1395C4.04741 11.787 3.53991 12.2945 2.8924 12.5107L1.43989 12.9945C1.38576 13.0124 1.33865 13.0469 1.30526 13.0932C1.27188 13.1394 1.25391 13.195 1.25391 13.252C1.25391 13.309 1.27188 13.3646 1.30526 13.4108Z"
        fill="url(#paint0_linear_31956_36699)"
      />
      <path
        d="M7.80547 7.82192C7.39297 7.95942 7.39297 8.54192 7.80547 8.67943L10.2267 9.48568C10.7589 9.66302 11.2424 9.96183 11.639 10.3584C12.0356 10.7551 12.3344 11.2386 12.5118 11.7707L13.318 14.192C13.3477 14.2823 13.4051 14.361 13.4821 14.4167C13.5591 14.4725 13.6517 14.5025 13.7468 14.5025C13.8418 14.5025 13.9345 14.4725 14.0115 14.4167C14.0885 14.361 14.1459 14.2823 14.1755 14.192L14.9818 11.7707C15.1591 11.2386 15.4579 10.7551 15.8545 10.3584C16.2512 9.96183 16.7347 9.66302 17.2668 9.48568L19.6881 8.67942C19.7784 8.64978 19.857 8.59237 19.9128 8.51537C19.9686 8.43838 19.9986 8.34574 19.9986 8.25067C19.9986 8.1556 19.9686 8.06296 19.9128 7.98597C19.857 7.90898 19.7784 7.85156 19.6881 7.82192L17.268 7.01566C16.7357 6.83849 16.2519 6.53975 15.8551 6.14313C15.4582 5.74651 15.1592 5.2629 14.9818 4.73065L14.1755 2.30938C14.038 1.89687 13.4555 1.89687 13.318 2.30938L12.5118 4.7294C12.3346 5.26175 12.0358 5.74552 11.6392 6.14236C11.2426 6.53919 10.759 6.8382 10.2267 7.01566L7.80547 7.82192Z"
        fill="url(#paint1_linear_31956_36699)"
      />
      <path
        d="M0.03358 4.60324C0.0554231 4.63394 0.0862863 4.65706 0.121879 4.6694H0.123129L1.08939 4.99065C1.52189 5.1344 1.86064 5.47316 2.00439 5.90566L2.32689 6.87316C2.33923 6.90876 2.36236 6.93962 2.39305 6.96146C2.42374 6.98331 2.46048 6.99504 2.49815 6.99504C2.53582 6.99504 2.57255 6.98331 2.60324 6.96146C2.63393 6.93962 2.65706 6.90876 2.6694 6.87316L2.9919 5.90691C3.0628 5.69377 3.18242 5.50009 3.34126 5.34126C3.50009 5.18242 3.69377 5.06281 3.90691 4.9919L4.87441 4.6694C4.91001 4.65706 4.94087 4.63394 4.96271 4.60324C4.98455 4.57255 4.99629 4.53582 4.99629 4.49815C4.99629 4.46048 4.98455 4.42374 4.96271 4.39305C4.94087 4.36236 4.91001 4.33924 4.87441 4.3269L3.90691 4.00439C3.69377 3.93349 3.50009 3.81387 3.34126 3.65504C3.18242 3.4962 3.0628 3.30253 2.9919 3.08939L2.6694 2.12188C2.65706 2.08629 2.63393 2.05542 2.60324 2.03358C2.57255 2.01174 2.53582 2 2.49815 2C2.46047 2 2.42374 2.01174 2.39305 2.03358C2.36236 2.05542 2.33923 2.08629 2.32689 2.12188L2.00439 3.08939C1.86064 3.52189 1.52189 3.86064 1.08939 4.00439L0.121879 4.3269C0.0862862 4.33924 0.0554231 4.36236 0.03358 4.39305C0.0117369 4.42374 0 4.46048 0 4.49815C0 4.53582 0.0117369 4.57255 0.03358 4.60324Z"
        fill="url(#paint2_linear_31956_36699)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31956_36699"
          x1="8.7556"
          y1="14.0013"
          x2="0.352696"
          y2="13.7964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B677E5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_31956_36699"
          x1="19.998"
          y1="9.5"
          x2="5.99418"
          y2="9.15848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B677E5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_31956_36699"
          x1="4.99607"
          y1="4.99643"
          x2="-0.600197"
          y2="4.85991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B677E5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export const AllCandidatesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3337 2.8898C14.5684 3.50343 15.417 4.77762 15.417 6.25C15.417 7.72238 14.5684 8.99657 13.3337 9.6102M15.0003 13.972C16.2599 14.5419 17.3941 15.4708 18.3337 16.6667M1.66699 16.6667C3.28907 14.6021 5.49131 13.3333 7.91699 13.3333C10.3427 13.3333 12.5449 14.6021 14.167 16.6667M11.667 6.25C11.667 8.32107 9.98806 10 7.91699 10C5.84592 10 4.16699 8.32107 4.16699 6.25C4.16699 4.17893 5.84592 2.5 7.91699 2.5C9.98806 2.5 11.667 4.17893 11.667 6.25Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ShortListedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99462 4.27985C8.32849 2.332 5.55011 1.80804 3.46257 3.59168C1.37503 5.37532 1.08113 8.35748 2.72049 10.467C4.08351 12.2209 8.20847 15.9201 9.56041 17.1174C9.71166 17.2513 9.78729 17.3183 9.8755 17.3446C9.9525 17.3676 10.0367 17.3676 10.1137 17.3446C10.2019 17.3183 10.2776 17.2513 10.4288 17.1174C11.7808 15.9201 15.9057 12.2209 17.2687 10.467C18.9081 8.35748 18.6501 5.35656 16.5267 3.59168C14.4032 1.8268 11.6607 2.332 9.99462 4.27985Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const QualifiedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.3337 9.23818V10.0049C18.3326 11.8019 17.7507 13.5504 16.6748 14.9897C15.5988 16.429 14.0864 17.4819 12.3631 17.9914C10.6399 18.501 8.79804 18.4398 7.11238 17.817C5.42673 17.1942 3.98754 16.0433 3.00946 14.5357C2.03138 13.0282 1.56682 11.2449 1.68506 9.45178C1.80329 7.65866 2.498 5.95179 3.66556 4.58575C4.83312 3.2197 6.41098 2.26767 8.16382 1.87164C9.91665 1.47561 11.7505 1.6568 13.392 2.38818M18.3337 3.33341L10.0003 11.6751L7.50033 9.17508"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DisregardedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M11 1L1 11M1 1L11 11"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GinoReportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.75033 18.3332V14.1665M3.75033 5.83317V1.6665M1.66699 3.74984H5.83366M1.66699 16.2498H5.83366M10.8337 2.49984L9.38851 6.25722C9.1535 6.86825 9.036 7.17376 8.85327 7.43074C8.69132 7.6585 8.49232 7.8575 8.26456 8.01945C8.00758 8.20217 7.70207 8.31968 7.09104 8.55469L3.33366 9.99984L7.09105 11.445C7.70207 11.68 8.00758 11.7975 8.26456 11.9802C8.49232 12.1422 8.69132 12.3412 8.85327 12.5689C9.036 12.8259 9.1535 13.1314 9.38851 13.7425L10.8337 17.4998L12.2788 13.7425C12.5138 13.1314 12.6313 12.8259 12.8141 12.5689C12.976 12.3412 13.175 12.1422 13.4028 11.9802C13.6597 11.7975 13.9653 11.68 14.5763 11.445L18.3337 9.99984L14.5763 8.55469C13.9652 8.31968 13.6597 8.20217 13.4028 8.01945C13.175 7.8575 12.976 7.6585 12.8141 7.43074C12.6313 7.17376 12.5138 6.86825 12.2788 6.25722L10.8337 2.49984Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MessageIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.83333 7.08333H10M5.83333 10H12.5M5.83333 15V16.9463C5.83333 17.3903 5.83333 17.6123 5.92436 17.7263C6.00352 17.8255 6.12356 17.8832 6.25045 17.8831C6.39636 17.8829 6.56973 17.7442 6.91646 17.4668L8.90434 15.8765C9.31043 15.5517 9.51347 15.3892 9.73957 15.2737C9.94017 15.1712 10.1537 15.0963 10.3743 15.051C10.6231 15 10.8831 15 11.4031 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.6667C2.5 12.4416 2.5 12.8291 2.58519 13.147C2.81635 14.0098 3.49022 14.6836 4.35295 14.9148C4.67087 15 5.05836 15 5.83333 15Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AddReviewIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6663 8.74984V5.6665C16.6663 4.26637 16.6663 3.56631 16.3939 3.03153C16.1542 2.56112 15.7717 2.17867 15.3013 1.93899C14.7665 1.6665 14.0665 1.6665 12.6663 1.6665H7.33301C5.93288 1.6665 5.23281 1.6665 4.69803 1.93899C4.22763 2.17867 3.84517 2.56112 3.60549 3.03153C3.33301 3.56631 3.33301 4.26637 3.33301 5.6665V14.3332C3.33301 15.7333 3.33301 16.4334 3.60549 16.9681C3.84517 17.4386 4.22763 17.821 4.69803 18.0607C5.23281 18.3332 5.93288 18.3332 7.33301 18.3332H9.99967M11.6663 9.1665H6.66634M8.33301 12.4998H6.66634M13.333 5.83317H6.66634M14.9997 17.4998V12.4998M12.4997 14.9998H17.4997"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ViewReviewIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.666 0.833984C11.3521 0.833984 11.9174 0.832687 12.376 0.870117C12.8443 0.908384 13.2753 0.991241 13.6797 1.19727C14.3068 1.51682 14.8172 2.02623 15.1367 2.65332C15.3427 3.0577 15.4246 3.4887 15.4629 3.95703C15.5003 4.41567 15.5 4.98082 15.5 5.66699V10.417C15.4998 10.8771 15.1261 11.25 14.666 11.25C14.2062 11.2496 13.8332 10.8769 13.833 10.417V5.66699C13.833 4.95336 13.8324 4.46781 13.8018 4.09277C13.7719 3.72759 13.7177 3.54047 13.6514 3.41016C13.4916 3.09662 13.2364 2.84141 12.9229 2.68164C12.7925 2.61532 12.6052 2.56107 12.2402 2.53125C11.8652 2.50065 11.3795 2.5 10.666 2.5H5.33301C4.61937 2.5 4.13381 2.50061 3.75879 2.53125C3.39371 2.56111 3.20646 2.61526 3.07617 2.68164C2.76276 2.84144 2.50738 3.09669 2.34766 3.41016C2.28134 3.54047 2.22709 3.72782 2.19727 4.09277C2.16665 4.4678 2.16602 4.95339 2.16602 5.66699V14.334C2.16602 15.0474 2.16663 15.5332 2.19727 15.9082C2.22709 16.2726 2.28141 16.4596 2.34766 16.5898C2.50738 16.9033 2.76279 17.1586 3.07617 17.3184C3.20646 17.3847 3.39371 17.4389 3.75879 17.4688C4.13381 17.4994 4.61937 17.5 5.33301 17.5H8C8.46009 17.5002 8.83301 17.8739 8.83301 18.334C8.83266 18.7938 8.45987 19.1668 8 19.167H5.33301C4.64684 19.167 4.08166 19.1674 3.62305 19.1299C3.1548 19.0916 2.72366 19.0097 2.31934 18.8037C1.69236 18.4841 1.18279 17.9737 0.863281 17.3467C0.657345 16.9425 0.574425 16.5121 0.536133 16.0439C0.498668 15.5854 0.499999 15.02 0.5 14.334V5.66699C0.5 4.98085 0.498685 4.41566 0.536133 3.95703C0.574394 3.4888 0.657361 3.05763 0.863281 2.65332C1.18274 2.02657 1.69264 1.5168 2.31934 1.19727C2.72366 0.991253 3.1548 0.908404 3.62305 0.870117C4.08166 0.832647 4.64684 0.833984 5.33301 0.833984H10.666ZM11.418 11.9004C12.4898 11.9004 13.3558 12.3738 13.9844 12.8984C14.6114 13.4218 15.0385 14.0244 15.252 14.3623C15.2801 14.4069 15.3347 14.4871 15.377 14.5977L15.4141 14.7188L15.4307 14.8223C15.4419 14.9289 15.4367 15.0439 15.4141 15.1426C15.3741 15.3166 15.2895 15.4395 15.252 15.499C15.0385 15.8369 14.6111 16.4387 13.9844 16.9619C13.3558 17.4866 12.4898 17.9609 11.418 17.9609C10.3462 17.9609 9.48111 17.4865 8.85254 16.9619C8.22547 16.4385 7.79743 15.837 7.58398 15.499C7.54643 15.4396 7.46281 15.3165 7.42285 15.1426C7.39269 15.011 7.39269 14.8503 7.42285 14.7188C7.46279 14.5447 7.54642 14.4218 7.58398 14.3623C7.7974 14.0244 8.22536 13.4219 8.85254 12.8984C9.48108 12.3739 10.3465 11.9004 11.418 11.9004ZM11.418 13.0996C10.7172 13.0997 10.1149 13.4082 9.62109 13.8203C9.16709 14.1993 8.83614 14.6423 8.64746 14.9297C8.83602 15.2171 9.1664 15.6615 9.62109 16.041C10.1149 16.4531 10.7172 16.7607 11.418 16.7607C12.1187 16.7607 12.7211 16.4531 13.2148 16.041C13.6693 15.6618 13.9989 15.2171 14.1875 14.9297C13.9987 14.6422 13.6686 14.199 13.2148 13.8203C12.721 13.4082 12.1187 13.0996 11.418 13.0996ZM11.418 13.2891C12.3246 13.2891 13.0596 14.024 13.0596 14.9307C13.0595 15.8373 12.3246 16.5723 11.418 16.5723C10.5114 16.5722 9.77643 15.8372 9.77637 14.9307C9.77637 14.024 10.5114 13.2891 11.418 13.2891ZM11.418 14.4893C11.1741 14.4893 10.9766 14.6868 10.9766 14.9307C10.9766 15.1745 11.1741 15.372 11.418 15.3721C11.6619 15.3721 11.8593 15.1745 11.8594 14.9307C11.8594 14.6867 11.6619 14.4893 11.418 14.4893ZM6.33301 11.667C6.79314 11.667 7.16584 12.0399 7.16602 12.5C7.16584 12.9601 6.79314 13.334 6.33301 13.334H4.66602C4.20619 13.3336 3.83318 12.9599 3.83301 12.5C3.83318 12.0401 4.20619 11.6673 4.66602 11.667H6.33301ZM9.66602 8.33398C10.1263 8.33398 10.5 8.70676 10.5 9.16699C10.4998 9.62708 10.1261 10 9.66602 10H4.66602C4.20619 9.99964 3.83318 9.62686 3.83301 9.16699C3.83301 8.70697 4.20608 8.33434 4.66602 8.33398H9.66602ZM11.333 5C11.7932 5 12.166 5.37375 12.166 5.83398C12.1657 6.29393 11.793 6.66699 11.333 6.66699H4.66602C4.2063 6.66664 3.83335 6.29371 3.83301 5.83398C3.83301 5.37397 4.20608 5.00036 4.66602 5H11.333Z"
        fill="#475467"
      />
    </SvgIcon>
  );
};

export const ViewReviewButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AddReviewButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M6 1V11" stroke="#008B07" strokeWidth="2" strokeLinecap="round" />
      <path d="M11 6L1 6" stroke="#008B07" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const StrengthItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" rx="12" fill="#C9FFC4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.096 7.38967L9.93602 14.2997L8.03602 12.2697C7.68602 11.9397 7.13602 11.9197 6.73602 12.1997C6.34602 12.4897 6.23602 12.9997 6.47602 13.4097L8.72602 17.0697C8.94602 17.4097 9.32601 17.6197 9.75601 17.6197C10.166 17.6197 10.556 17.4097 10.776 17.0697C11.136 16.5997 18.006 8.40967 18.006 8.40967C18.906 7.48967 17.816 6.67967 17.096 7.37967V7.38967Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const GapItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" rx="12" fill="#FCEFD4" />
      <path
        d="M12 13C12.4142 13 12.75 12.5523 12.75 12C12.75 11.4477 12.4142 11 12 11C11.5858 11 11.25 11.4477 11.25 12C11.25 12.5523 11.5858 13 12 13Z"
        stroke="#F3BC4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 13C17.6642 13 18 12.5523 18 12C18 11.4477 17.6642 11 17.25 11C16.8358 11 16.5 11.4477 16.5 12C16.5 12.5523 16.8358 13 17.25 13Z"
        stroke="#F3BC4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 13C7.16421 13 7.5 12.5523 7.5 12C7.5 11.4477 7.16421 11 6.75 11C6.33579 11 6 11.4477 6 12C6 12.5523 6.33579 13 6.75 13Z"
        stroke="#F3BC4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "17", height: "14", fill: "none" }}
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <path d="M16 7H2M2 7L8 1M2 7L8 13" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};
